/**
 * ButtonGroup modules
 */
export * from './button-group';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-splitbuttons/src/button-group/index.js
// module id = 1896
// module chunks = 0